export default __webpack_public_path__ + "assets/fb30bb656b6a6a4713b5d74abe15cdff.png";